/**
 * @file Generated by js-routes 2.4.1. Based on Rails 8.1.4 routes of ReadingNow::Application.
 * @version 8abcbaf9100ceaa21f10906081ba3a838b4032dc31e4bdd1b3d3d7d05bbdd922
 * @see https://github.com/railsware/js-routes
 */
// @ts-nocheck
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Router = (() => {
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class Router {
        constructor(config = {}) {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "__options__",
                serializer: this.default_serializer.bind(this),
                deprecated_false_parameter_behavior: false,
                deprecated_nil_query_parameter_behavior: false,
                include_undefined_query_parameters: true,
            };
            this.configure(config);
        }
        configure(new_config) {
            var _a;
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            (_a = new_config.serializer) !== null && _a !== void 0 ? _a : (new_config.serializer = this.default_serializer.bind(this));
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        __route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        default_serializer(value, prefix, array_element = false) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("URL parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                // Rails serializes an empty array nested inside another array as a nil
                // query value, while an empty object contributes no query parameter.
                if (value.length === 0) {
                    return array_element
                        ? this.default_serializer(null, prefix + "[]")
                        : "";
                }
                for (const element of value) {
                    const subvalue = this.default_serializer(element, prefix + "[]", true);
                    // Skip empty object results so arrays do not produce leading,
                    // trailing, or doubled "&" separators.
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!this.hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (!this.configuration.include_undefined_query_parameters &&
                        prop === undefined) {
                        continue;
                    }
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                const key = encodeURIComponent(prefix);
                result.push(this.is_not_nullable(value) ||
                    this.configuration.deprecated_nil_query_parameter_behavior
                    ? key + "=" + encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : key);
            }
            return result.join("&");
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) && !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (this.configuration.deprecated_false_parameter_behavior &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!this.hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!this.hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!this.hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !this.hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        hasProp(value, key) {
            return Object.prototype.hasOwnProperty.call(value, key);
        }
    }
    return Router;
})();
const __jsr = (() => {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    ;
    const Modules = {
        references: {
            CJS: {
                define(routes) {
                    if (module) {
                        // Some javascript processors (like vite/rolldown)
                        // warn on using module dot exports in an ESM module.
                        // This just obfuscates that assignment a little so
                        // users don't get a warning they can't fix.
                        const _mod = module;
                        _mod.exports = routes;
                    }
                },
                isSupported() {
                    return typeof module === "object";
                },
            },
            AMD: {
                define(routes) {
                    if (define) {
                        define([], function () {
                            return routes;
                        });
                    }
                },
                isSupported() {
                    return typeof define === "function" && !!define.amd;
                },
            },
            UMD: {
                define(routes) {
                    if (Modules.references.AMD.isSupported()) {
                        Modules.references.AMD.define(routes);
                    }
                    else {
                        if (Modules.references.CJS.isSupported()) {
                            try {
                                Modules.references.CJS.define(routes);
                            }
                            catch (error) {
                                if (error.name !== "TypeError")
                                    throw error;
                            }
                        }
                    }
                },
                isSupported() {
                    return (Modules.references.AMD.isSupported() ||
                        Modules.references.CJS.isSupported());
                },
            },
            ESM: {
                define() {
                    // Module can only be defined using ruby code generation
                },
                isSupported() {
                    // Its impossible to check if "export" keyword is supported
                    return true;
                },
            },
            NIL: {
                define() {
                    // Defined using RubyVariables . WRAPPER
                },
                isSupported() {
                    return true;
                },
            },
            DTS: {
                // Acts the same as ESM
                define(routes) {
                    Modules.references.ESM.define(routes);
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
            PKG: {
                // Acts the same as ESM
                define() {
                    Modules.references.ESM.define(new Router());
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
        },
        is_module_supported(name) {
            return this.references[name].isSupported();
        },
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        },
        define_module(name, module) {
            this.ensure_module_supported(name);
            this.references[name].define(module);
            return module;
        },
    };
    const router = new Router({
        prefix: "",
        default_url_options: {},
        special_options_key: "_options",
        serializer: (_a = null) !== null && _a !== void 0 ? _a : undefined,
        deprecated_false_parameter_behavior: false,
        deprecated_nil_query_parameter_behavior: false,
        include_undefined_query_parameters: false,
    });
    const __route = router.__route.bind(router);
    return Modules.define_module("ESM", {
        __route,
        configure: router.configure.bind(router),
        config: router.config.bind(router),
        serialize: router.serialize.bind(router),
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

export const __route = __jsr.__route;

/**
 * Generates rails route to
 * /about(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const about_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"about"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /abuse_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abuse_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"abuse_reports"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /clubs/:club_id/invitations/:id/accept(.:format)
 * @param {any} club_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accept_club_invitation_path = /*#__PURE__*/ __route({"club_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clubs"],[2,[7,"/"],[2,[3,"club_id"],[2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /clubs/:club_id/requests/:id/accept(.:format)
 * @param {any} club_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accept_club_request_path = /*#__PURE__*/ __route({"club_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clubs"],[2,[7,"/"],[2,[3,"club_id"],[2,[7,"/"],[2,[6,"requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_deletion_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/account/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_export_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reads/add_book(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_book_reads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reads"],[2,[7,"/"],[2,[6,"add_book"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:username/lists/:booklist_id/booklist_items/add_book(.:format)
 * @param {any} username
 * @param {any} booklist_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_book_user_booklist_booklist_items_path = /*#__PURE__*/ __route({"username":{"r":true},"booklist_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"lists"],[2,[7,"/"],[2,[3,"booklist_id"],[2,[7,"/"],[2,[6,"booklist_items"],[2,[7,"/"],[2,[6,"add_book"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /book_scans/:id/add_to_quick_add(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_to_quick_add_ocr_scan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book_scans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_to_quick_add"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/abuse_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_abuse_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"abuse_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/authors/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_author_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"authors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/authors/:author_id/contact(.:format)
 * @param {any} author_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_author_contact_path = /*#__PURE__*/ __route({"author_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"authors"],[2,[7,"/"],[2,[3,"author_id"],[2,[7,"/"],[2,[6,"contact"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/authors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_authors_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"authors"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/books/cover_migration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_books_cover_migration_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"books"],[2,[7,"/"],[2,[6,"cover_migration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/books/data_integrity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_books_data_integrity_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"books"],[2,[7,"/"],[2,[6,"data_integrity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/data_flags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_data_flags_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"data_flags"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_suppressions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_email_suppression_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_suppressions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_suppressions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_email_suppressions_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_suppressions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/enrichments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_enrichments_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"enrichments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/featured(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_featured_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"featured"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/genres/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_genre_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"genres"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/genres(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_genres_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"genres"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/genres/data_quality(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_genres_data_quality_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"genres"],[2,[7,"/"],[2,[6,"data_quality"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/genres/hierarchy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_genres_hierarchy_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"genres"],[2,[7,"/"],[2,[6,"hierarchy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/google_books_usage(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_google_books_usage_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"google_books_usage"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/import_runs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_import_run_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"import_runs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/import_runs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_import_runs_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"import_runs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/push_notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_push_notifications_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"push_notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_root_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/series/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_series_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"series"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/series(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_series_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"series"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_users_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /analytics/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytics_events_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /challenges/:id/archive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archive_challenge_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /authors/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const author_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"authors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /awards/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_path = /*#__PURE__*/ __route({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /awards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const awards_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"awards"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /bestsellers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bestseller_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bestsellers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /bestsellers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bestsellers_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"bestsellers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /books/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const book_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"books"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /books/:book_id/discovery_dismissal(.:format)
 * @param {any} book_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const book_discovery_dismissal_path = /*#__PURE__*/ __route({"book_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"books"],[2,[7,"/"],[2,[3,"book_id"],[2,[7,"/"],[2,[6,"discovery_dismissal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /books/:book_id/reviews(.:format)
 * @param {any} book_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const book_reviews_path = /*#__PURE__*/ __route({"book_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"books"],[2,[7,"/"],[2,[3,"book_id"],[2,[7,"/"],[2,[6,"reviews"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /books(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const books_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"books"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /calendar.ics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calendar_feed_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"calendar"],[2,[8,"."],[2,[6,"ics"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /catalog/books/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const catalog_book_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"catalog"],[2,[7,"/"],[2,[6,"books"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /catalog/books/:book_id/enrichments(.:format)
 * @param {any} book_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const catalog_book_enrichments_path = /*#__PURE__*/ __route({"book_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"catalog"],[2,[7,"/"],[2,[6,"books"],[2,[7,"/"],[2,[3,"book_id"],[2,[7,"/"],[2,[6,"enrichments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /catalog/books(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const catalog_books_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"catalog"],[2,[7,"/"],[2,[6,"books"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /challenges/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const challenge_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /challenges/:challenge_id/leaderboard(.:format)
 * @param {any} challenge_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const challenge_leaderboard_path = /*#__PURE__*/ __route({"challenge_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[3,"challenge_id"],[2,[7,"/"],[2,[6,"leaderboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /challenges/:challenge_id/participation(.:format)
 * @param {any} challenge_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const challenge_participation_path = /*#__PURE__*/ __route({"challenge_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[3,"challenge_id"],[2,[7,"/"],[2,[6,"participation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /challenges(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const challenges_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"challenges"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /changelog(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const changelog_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"changelog"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /catalog/books/:id/clear_cover(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clear_cover_catalog_book_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"catalog"],[2,[7,"/"],[2,[6,"books"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clear_cover"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /clubs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const club_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clubs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /clubs/:club_id/calendar_subscription(.:format)
 * @param {any} club_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const club_calendar_subscription_path = /*#__PURE__*/ __route({"club_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clubs"],[2,[7,"/"],[2,[3,"club_id"],[2,[7,"/"],[2,[6,"calendar_subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /clubs/:club_id/guest_members/:id(.:format)
 * @param {any} club_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const club_guest_member_path = /*#__PURE__*/ __route({"club_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clubs"],[2,[7,"/"],[2,[3,"club_id"],[2,[7,"/"],[2,[6,"guest_members"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /clubs/:club_id/guest_members(.:format)
 * @param {any} club_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const club_guest_members_path = /*#__PURE__*/ __route({"club_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clubs"],[2,[7,"/"],[2,[3,"club_id"],[2,[7,"/"],[2,[6,"guest_members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /clubs/:club_id/invitations/:id(.:format)
 * @param {any} club_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const club_invitation_path = /*#__PURE__*/ __route({"club_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clubs"],[2,[7,"/"],[2,[3,"club_id"],[2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /clubs/:club_id/invitations(.:format)
 * @param {any} club_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const club_invitations_path = /*#__PURE__*/ __route({"club_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clubs"],[2,[7,"/"],[2,[3,"club_id"],[2,[7,"/"],[2,[6,"invitations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /clubs/:club_id/meetings/:id(.:format)
 * @param {any} club_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const club_meeting_path = /*#__PURE__*/ __route({"club_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clubs"],[2,[7,"/"],[2,[3,"club_id"],[2,[7,"/"],[2,[6,"meetings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /clubs/:club_id/meetings/:meeting_id/attendances/:id(.:format)
 * @param {any} club_id
 * @param {any} meeting_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const club_meeting_attendance_path = /*#__PURE__*/ __route({"club_id":{"r":true},"meeting_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clubs"],[2,[7,"/"],[2,[3,"club_id"],[2,[7,"/"],[2,[6,"meetings"],[2,[7,"/"],[2,[3,"meeting_id"],[2,[7,"/"],[2,[6,"attendances"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /clubs/:club_id/meetings/:meeting_id/attendances(.:format)
 * @param {any} club_id
 * @param {any} meeting_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const club_meeting_attendances_path = /*#__PURE__*/ __route({"club_id":{"r":true},"meeting_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clubs"],[2,[7,"/"],[2,[3,"club_id"],[2,[7,"/"],[2,[6,"meetings"],[2,[7,"/"],[2,[3,"meeting_id"],[2,[7,"/"],[2,[6,"attendances"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /clubs/:club_id/meetings/:meeting_id/calendar(.:format)
 * @param {any} club_id
 * @param {any} meeting_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const club_meeting_calendar_path = /*#__PURE__*/ __route({"club_id":{"r":true},"meeting_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clubs"],[2,[7,"/"],[2,[3,"club_id"],[2,[7,"/"],[2,[6,"meetings"],[2,[7,"/"],[2,[3,"meeting_id"],[2,[7,"/"],[2,[6,"calendar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /clubs/:club_id/meetings(.:format)
 * @param {any} club_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const club_meetings_path = /*#__PURE__*/ __route({"club_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clubs"],[2,[7,"/"],[2,[3,"club_id"],[2,[7,"/"],[2,[6,"meetings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /clubs/:club_id/members(.:format)
 * @param {any} club_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const club_members_path = /*#__PURE__*/ __route({"club_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clubs"],[2,[7,"/"],[2,[3,"club_id"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /clubs/:club_id/memberships/:id(.:format)
 * @param {any} club_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const club_membership_path = /*#__PURE__*/ __route({"club_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clubs"],[2,[7,"/"],[2,[3,"club_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /clubs/:club_id/requests(.:format)
 * @param {any} club_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const club_requests_path = /*#__PURE__*/ __route({"club_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clubs"],[2,[7,"/"],[2,[3,"club_id"],[2,[7,"/"],[2,[6,"requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /clubs/:club_id/statistics(.:format)
 * @param {any} club_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const club_statistics_path = /*#__PURE__*/ __route({"club_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clubs"],[2,[7,"/"],[2,[3,"club_id"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /clubs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clubs_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"clubs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /comments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /comments/:comment_id/flags(.:format)
 * @param {any} comment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comment_flags_path = /*#__PURE__*/ __route({"comment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"comment_id"],[2,[7,"/"],[2,[6,"flags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /comment_flags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comment_flags_queue_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"comment_flags"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comments_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /identity/magic_link/confirm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_identity_email_login_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"magic_link"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /identity/email_verification/confirm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_identity_email_verification_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"email_verification"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /data_flags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_flags_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"data_flags"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /clubs/:club_id/invitations/:id/decline(.:format)
 * @param {any} club_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const decline_club_invitation_path = /*#__PURE__*/ __route({"club_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clubs"],[2,[7,"/"],[2,[3,"club_id"],[2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"decline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /clubs/:club_id/requests/:id/decline(.:format)
 * @param {any} club_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const decline_club_request_path = /*#__PURE__*/ __route({"club_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clubs"],[2,[7,"/"],[2,[3,"club_id"],[2,[7,"/"],[2,[6,"requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"decline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /discover(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discover_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"discover"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/authors/:author_id/contact/edit(.:format)
 * @param {any} author_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_author_contact_path = /*#__PURE__*/ __route({"author_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"authors"],[2,[7,"/"],[2,[3,"author_id"],[2,[7,"/"],[2,[6,"contact"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/genres/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_genre_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"genres"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /catalog/books/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_catalog_book_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"catalog"],[2,[7,"/"],[2,[6,"books"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /challenges/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_challenge_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /clubs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_club_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clubs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /clubs/:club_id/meetings/:id/edit(.:format)
 * @param {any} club_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_club_meeting_path = /*#__PURE__*/ __route({"club_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clubs"],[2,[7,"/"],[2,[3,"club_id"],[2,[7,"/"],[2,[6,"meetings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /identity/password_reset/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_identity_password_reset_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"password_reset"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_password_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:username/lists/:id/edit(.:format)
 * @param {any} username
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_booklist_path = /*#__PURE__*/ __route({"username":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:username/goals/:id/edit(.:format)
 * @param {any} username
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_goal_path = /*#__PURE__*/ __route({"username":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"goals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:username/reads/:id/edit(.:format)
 * @param {any} username
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_read_path = /*#__PURE__*/ __route({"username":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"reads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:username/reads/:read_id/review/edit(.:format)
 * @param {any} username
 * @param {any} read_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_read_review_path = /*#__PURE__*/ __route({"username":{"r":true},"read_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"reads"],[2,[7,"/"],[2,[3,"read_id"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email/reading_circle/unsubscribe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_reading_circle_unsubscribe_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"reading_circle"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /catalog/books/:id/enrich_column(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enrich_column_catalog_book_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"catalog"],[2,[7,"/"],[2,[6,"books"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enrich_column"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /featured(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const featured_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"featured"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/series/:id/find_goodreads_url(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const find_goodreads_url_admin_series_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"series"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"find_goodreads_url"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /genres/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const genre_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"genres"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /genres(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const genres_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"genres"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /:username/goals/:id/history(.:format)
 * @param {any} username
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const history_user_goal_path = /*#__PURE__*/ __route({"username":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"goals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /identity/magic_link(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const identity_email_login_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"magic_link"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /identity/email_verification(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const identity_email_verification_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"email_verification"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /identity/password_reset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const identity_password_reset_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"password_reset"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/authors/:id/import_books(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_books_admin_author_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"authors"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"import_books"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/series/:id/import_books(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_books_admin_series_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"series"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"import_books"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /inbox(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inbox_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"inbox"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /inbox/count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inbox_count_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[6,"count"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /notifications/mark_all_as_read(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_all_as_read_notifications_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"mark_all_as_read"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /notifications/:id/mark_as_read(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_read_notification_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_read"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /catalog/books/merge(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const merge_catalog_books_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"catalog"],[2,[7,"/"],[2,[6,"books"],[2,[7,"/"],[2,[6,"merge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/import_runs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_import_run_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"import_runs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /catalog/books/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_catalog_book_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"catalog"],[2,[7,"/"],[2,[6,"books"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /challenges/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_challenge_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /clubs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_club_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"clubs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /clubs/:club_id/meetings/new(.:format)
 * @param {any} club_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_club_meeting_path = /*#__PURE__*/ __route({"club_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clubs"],[2,[7,"/"],[2,[3,"club_id"],[2,[7,"/"],[2,[6,"meetings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /identity/password_reset/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_identity_password_reset_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"password_reset"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth/registration/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_oauth_registration_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /book_scans/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ocr_scan_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"book_scans"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:username/lists/new(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_booklist_path = /*#__PURE__*/ __route({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:username/goals/new(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_goal_path = /*#__PURE__*/ __route({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"goals"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:username/reads/:read_id/review/new(.:format)
 * @param {any} username
 * @param {any} read_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_read_review_path = /*#__PURE__*/ __route({"username":{"r":true},"read_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"reads"],[2,[7,"/"],[2,[3,"read_id"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/:provider/callback(.:format)
 * @param {any} provider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_callback_path = /*#__PURE__*/ __route({"provider":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[3,"provider"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/failure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_failure_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"failure"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/registration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_registration_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"registration"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /book_scans/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ocr_scan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book_scans"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /book_scans(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ocr_scans_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"book_scans"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /offline/booklists/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const offline_booklist_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"offline"],[2,[7,"/"],[2,[6,"booklists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /offline/booklists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const offline_booklists_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"offline"],[2,[7,"/"],[2,[6,"booklists"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/offline(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const offline_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"offline"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const password_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /:username/challenges/:challenge_id/completions/plan(.:format)
 * @param {any} username
 * @param {any} challenge_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plan_user_challenge_completions_path = /*#__PURE__*/ __route({"username":{"r":true},"challenge_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[3,"challenge_id"],[2,[7,"/"],[2,[6,"completions"],[2,[7,"/"],[2,[6,"plan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /privacy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const privacy_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"privacy"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /:username(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profile_path = /*#__PURE__*/ __route({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /:username/goals/:id/purge(.:format)
 * @param {any} username
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purge_user_goal_path = /*#__PURE__*/ __route({"username":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"goals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"purge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /push_subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const push_subscriptions_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"push_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /manifest(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pwa_manifest_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"manifest"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /service-worker(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pwa_service_worker_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"service-worker"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_path = /*#__PURE__*/ __route({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_path = /*#__PURE__*/ __route({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_path = /*#__PURE__*/ __route({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_health_check_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_path = /*#__PURE__*/ __route({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_path = /*#__PURE__*/ __route({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /random(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const random_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"random"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /random/pick(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const random_pick_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"random"],[2,[7,"/"],[2,[6,"pick"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/randomize_avatar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const randomize_avatar_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"randomize_avatar"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reactions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reaction_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reactions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /reads/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const read_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reads/:read_id/reading_journal_entries(.:format)
 * @param {any} read_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const read_reading_journal_entries_path = /*#__PURE__*/ __route({"read_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reads"],[2,[7,"/"],[2,[3,"read_id"],[2,[7,"/"],[2,[6,"reading_journal_entries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reads/:read_id/reading_journal_entries/:id(.:format)
 * @param {any} read_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const read_reading_journal_entry_path = /*#__PURE__*/ __route({"read_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reads"],[2,[7,"/"],[2,[3,"read_id"],[2,[7,"/"],[2,[6,"reading_journal_entries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email/reading_circle/unsubscribe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reading_circle_unsubscribe_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"reading_circle"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reading/reminder(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reading_reminder_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reading"],[2,[7,"/"],[2,[6,"reminder"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reads"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /recommendations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recommendation_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"recommendations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /recommendations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recommendations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"recommendations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /referrals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const referrals_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"referrals"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /book_scans/:id/remove_from_quick_add(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_from_quick_add_ocr_scan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book_scans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_from_quick_add"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /clubs/:club_id/invitations/:id/resend(.:format)
 * @param {any} club_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_club_invitation_path = /*#__PURE__*/ __route({"club_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clubs"],[2,[7,"/"],[2,[3,"club_id"],[2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/abuse_reports/:id/resolve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolve_admin_abuse_report_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"abuse_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/data_flags/:id/resolve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolve_admin_data_flag_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"data_flags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_suppressions/:id/resolve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolve_admin_email_suppression_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_suppressions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /comment_flags/:id/resolve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolve_comment_flag_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comment_flags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /catalog/books/:id/retry_cover_download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retry_cover_download_catalog_book_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"catalog"],[2,[7,"/"],[2,[6,"books"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry_cover_download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __route({}, [7,"/"]);

/**
 * Generates rails route to
 * /search/booklists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_booklists_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"booklists"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /search/books(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_books_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"books"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /search/friends(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_friends_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"friends"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /search/user_reads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_user_reads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"user_reads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /search/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_users_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /catalog/books/:id/select_cover(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select_cover_catalog_book_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"catalog"],[2,[7,"/"],[2,[6,"books"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"select_cover"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /search/books/select(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select_search_books_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"books"],[2,[7,"/"],[2,[6,"select"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /series/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const series_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"series"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sessions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const session_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sessions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sessions_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"sessions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /settings/account/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_account_export_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/blocked(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_blocked_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"blocked"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/hidden_books(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_hidden_books_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"hidden_books"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/muted(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_muted_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"muted"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_notifications_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/reading_circle(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_reading_circle_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"reading_circle"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/reading_reminder(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_reading_reminder_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"reading_reminder"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sign_in_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sign_out_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sign_up_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /start(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const start_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"start"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/enrichments/stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stats_admin_enrichments_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"enrichments"],[2,[7,"/"],[2,[6,"stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const status_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /push_subscriptions/status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const status_push_subscriptions_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"push_subscriptions"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terms_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"terms"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/booklists/:id/toggle_featured(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_featured_admin_booklist_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"booklists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_featured"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/challenges/:id/toggle_featured(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_featured_admin_challenge_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_featured"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = /*#__PURE__*/ __route({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:username/block(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_block_path = /*#__PURE__*/ __route({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"block"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:username/lists/:id(.:format)
 * @param {any} username
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_booklist_path = /*#__PURE__*/ __route({"username":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:username/lists/:booklist_id/booklist_items/:id(.:format)
 * @param {any} username
 * @param {any} booklist_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_booklist_booklist_item_path = /*#__PURE__*/ __route({"username":{"r":true},"booklist_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"lists"],[2,[7,"/"],[2,[3,"booklist_id"],[2,[7,"/"],[2,[6,"booklist_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:username/lists/:booklist_id/booklist_items(.:format)
 * @param {any} username
 * @param {any} booklist_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_booklist_booklist_items_path = /*#__PURE__*/ __route({"username":{"r":true},"booklist_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"lists"],[2,[7,"/"],[2,[3,"booklist_id"],[2,[7,"/"],[2,[6,"booklist_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:username/lists(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_booklists_path = /*#__PURE__*/ __route({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"lists"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:username/challenges/:id(.:format)
 * @param {any} username
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_challenge_path = /*#__PURE__*/ __route({"username":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:username/challenges/:challenge_id/completions/:id(.:format)
 * @param {any} username
 * @param {any} challenge_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_challenge_completion_path = /*#__PURE__*/ __route({"username":{"r":true},"challenge_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[3,"challenge_id"],[2,[7,"/"],[2,[6,"completions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:username/challenges/:challenge_id/completions(.:format)
 * @param {any} username
 * @param {any} challenge_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_challenge_completions_path = /*#__PURE__*/ __route({"username":{"r":true},"challenge_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[3,"challenge_id"],[2,[7,"/"],[2,[6,"completions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:username/challenges(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_challenges_path = /*#__PURE__*/ __route({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"challenges"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:username/follow(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_follow_path = /*#__PURE__*/ __route({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"follow"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:username/followers(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_followers_path = /*#__PURE__*/ __route({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"followers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:username/following(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_following_path = /*#__PURE__*/ __route({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"following"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:username/goals/:id(.:format)
 * @param {any} username
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_goal_path = /*#__PURE__*/ __route({"username":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"goals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:username/goals(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_goals_path = /*#__PURE__*/ __route({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"goals"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:username/mute(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_mute_path = /*#__PURE__*/ __route({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"mute"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:username/reads/:id(.:format)
 * @param {any} username
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_read_path = /*#__PURE__*/ __route({"username":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"reads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:username/reads/:read_id/review(.:format)
 * @param {any} username
 * @param {any} read_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_read_review_path = /*#__PURE__*/ __route({"username":{"r":true},"read_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"reads"],[2,[7,"/"],[2,[3,"read_id"],[2,[7,"/"],[2,[6,"review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:username/reads/:read_id/review/vote(.:format)
 * @param {any} username
 * @param {any} read_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_read_review_vote_path = /*#__PURE__*/ __route({"username":{"r":true},"read_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"reads"],[2,[7,"/"],[2,[3,"read_id"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"vote"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:username/recaps/:period_type/:period(.:format)
 * @param {any} username
 * @param {any} period_type
 * @param {any} period
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_recap_path = /*#__PURE__*/ __route({"username":{"r":true},"period_type":{"r":true},"period":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"recaps"],[2,[7,"/"],[2,[3,"period_type"],[2,[7,"/"],[2,[3,"period"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:username/recaps(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_recaps_path = /*#__PURE__*/ __route({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"recaps"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:username/reviews(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_reviews_path = /*#__PURE__*/ __route({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"reviews"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:username/series/:id(.:format)
 * @param {any} username
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_series_path = /*#__PURE__*/ __route({"username":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"series"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:username/stats(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_stats_path = /*#__PURE__*/ __route({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"stats"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:username/streak(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_streak_path = /*#__PURE__*/ __route({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"streak"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/resend(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooks_resend_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"resend"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /whats_new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const whats_new_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"whats_new"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /awards/:slug/:year(.:format)
 * @param {any} slug
 * @param {any} year
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const year_award_path = /*#__PURE__*/ __route({"slug":{"r":true},"year":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[3,"year"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

